import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Checkbox from '@material-ui/core/Checkbox'
import Icon from 'react-fa'
import TextField from '@material-ui/core/TextField'
import classnames from 'classnames'
import { KEYS_ENTER, KEYS_ESCAPE } from '../../constants/keyboardKeys'
import { isNullOrEmpty } from '../../util/stringHelper'
import { SortableElement, SortableHandle } from 'react-sortable-hoc'
import localize from '../../higherOrderComponents/localize'

const ITEM_NAME_MAX_LENGTH = 200
const checkboxClassName = 'task-modal__checklist-item-checkbox'
const inputClassName = 'task-modal__checklist-item-name-input'

const DragHandle = SortableHandle((props) =>
  <span title={props.title} className='task-modal__checklist-drag-handle'>::</span>)

/**
 * @augments{ PureComponent<any, any> }
 */
class ChecklistItemRow extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      itemName: props.checklistItem.name
    }
  }

  saveChecklistItem = () => {
    const { checked, id, name } = this.props.checklistItem
    if (isNullOrEmpty(this.state.itemName)) {
      this.props.deleteTaskChecklistItem(id)
    } else if (this.state.itemName !== name) {
      this.props.saveTaskChecklistItem(id, this.state.itemName, checked)
    }
  }

  checklistItemNameOnKeyDown = (event) => {
    const textFieldSelector = `.${inputClassName}`
    const { rowIndex } = this.props

    if (event.key === KEYS_ENTER) {
      event.preventDefault()

      const elements = document.querySelectorAll(textFieldSelector)
      const isDeleteAction = isNullOrEmpty(event.target.value)
      if (rowIndex === elements.length - 1) {
        if (isDeleteAction && rowIndex) {
          elements[rowIndex - 1].focus()
        } else {
          elements[rowIndex].blur()
        }
      } else {
        elements[rowIndex + 1].focus()
      }

      if (this.props.isAdding && !isDeleteAction) {
        this.props.createTaskChecklistItem()
      }
    }

    if (event.key === KEYS_ESCAPE) {
      this.saveChecklistItem()
    }

    this.props.navigationHandler(event, textFieldSelector)
  }

  checklistItemNameOnFocus = (event) => {
    if (this.props.isAdding) {
      return
    }

    event.target.select()
  }

  checkboxOnKeyDown = (event) => {
    if (event.key === KEYS_ENTER) {
      this.props.saveTaskChecklistItem(this.props.checklistItem.id, this.state.itemName, !this.props.checklistItem.checked)
    }

    this.props.navigationHandler(event, `.${checkboxClassName} input`)
  }

  onCheck = (event, checked) => {
    this.props.saveTaskChecklistItem(this.props.checklistItem.id, this.state.itemName, checked)
  }

  render() {
    const { checklistItem, localize, isAdding } = this.props
    const itemNameInputClasses = {
      disabled: 'task-modal__checklist-item-name-disabled',
      underline: 'task-modal__checklist-item-name-underline',
      input: inputClassName
    }
    const itemNameInnerInputClasses = {
      root: 'task-modal__checklist-item-name-input-root',
      textarea: 'task-modal__checklist-item-name-textarea'
    }

    const itemClassname = classnames({
      'task-modal__checklist-item': true,
      'checked': checklistItem.checked
    })

    let canUpdate = checklistItem.actions.update

    return (
      <div className='task-modal__checklist-item-row'>
        <div className='task-modal__drag-handle-container'>
          { canUpdate && !isAdding &&
            <DragHandle title={localize('taskBoards.Label_DragToMoveChecklistItem')} />
          }
        </div>
        <div className={itemClassname}>
          <Checkbox
            checked={checklistItem.checked}
            disabled={isAdding || !canUpdate}
            className={checkboxClassName}
            icon={<Icon name='square-o' />}
            checkedIcon={<Icon name='check-square' />}
            onKeyDown={this.checkboxOnKeyDown}
            onChange={this.onCheck}
            />
          <TextField
            autoFocus={canUpdate && isAdding}
            className='task-modal__checklist-item-name'
            disabled={!canUpdate}
            onBlur={this.saveChecklistItem}
            onFocus={this.checklistItemNameOnFocus}
            onKeyDown={this.checklistItemNameOnKeyDown}
            multiline
            onChange={event => { this.setState({ itemName: event.target.value }) }}
            value={this.state.itemName}
            placeholder={isAdding ? localize('taskBoards.Text_AddChecklistItem') : undefined}
            InputProps={{ classes: itemNameInputClasses, disabled: !canUpdate }}
            inputProps={{ classes: itemNameInnerInputClasses, maxLength: ITEM_NAME_MAX_LENGTH }}
            />
          { checklistItem.actions.delete &&
            <div className='task-modal__checklist-delete-container'>
              <Icon
                className='task-modal__checklist-delete-button'
                name='remove'
                title={localize('taskBoards.Text_DeleteChecklistItem')}
                onClick={() => { this.props.deleteTaskChecklistItem(checklistItem.id) }}
              />
            </div>
          }
        </div>
      </div>
    )
  }
}

ChecklistItemRow.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  checklistItem: PropTypes.object.isRequired,
  createTaskChecklistItem: PropTypes.func.isRequired,
  deleteTaskChecklistItem: PropTypes.func.isRequired,
  isAdding: PropTypes.bool.isRequired,
  localize: PropTypes.func.isRequired,
  navigationHandler: PropTypes.func.isRequired,
  saveTaskChecklistItem: PropTypes.func.isRequired
}

export default SortableElement(localize(ChecklistItemRow))



// WEBPACK FOOTER //
// ./src/components/ChecklistPanel/ChecklistItemRow.js